/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : core.jsx
 * description   : {{insert here}}
 * creation date : 18/03/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    config_page_HOME_about,
    config_page_HOME_service,
    config_page_HOME_process,
    config_page_HOME_clients,
    config_page_HOME_contact,
    config_page_ACCOUNT,
    config_page_LEGAL,
    config_page_PRIVACY,
    config_page_COOKIES,
    config_page_CONTACT,
    config_page_DEMO,
} from '@/components/layouts/core';



// --------------------------------------------------------------------------------
//      CONSTANTS DEFINITION
// --------------------------------------------------------------------------------

const config_page_LIST_navbar =
    [
        config_page_HOME_about,
        config_page_HOME_service,
        config_page_HOME_process,
        config_page_HOME_clients,
        config_page_HOME_contact,
        config_page_DEMO,
    ];

const config_page_LIST_footer_contents =
    [
        config_page_HOME_about,
        config_page_HOME_service,
        config_page_HOME_process,
        config_page_HOME_clients,
        config_page_ACCOUNT,
    ];

const config_page_LIST_footer_legal =
    [
        config_page_LEGAL,
        config_page_PRIVACY,
        config_page_COOKIES,
        config_page_CONTACT,
    ];

const config_page_LIST_footer_demo =
    [
        config_page_DEMO,
    ];



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export {
    config_page_LIST_navbar,
    config_page_LIST_footer_contents,
    config_page_LIST_footer_legal,
    config_page_LIST_footer_demo,
};



// End of file
